<template>
  <fieldset
    v-if="boxes.length"
    :class="{
      'boxes-info': true,
      'has-differents-in-products': differentInProducts && differentInProducts.length
    }">
    <legend>
      {{ $t('order.warehouse.boxes.status.title') }}
    </legend>

    <d-badge
      v-if="differentInProducts && differentInProducts.length"
      theme="danger"
      class="w-100 mb-2 has-differnets-in-products-badge">
      {{ $t('order.warehouse.boxes.hasDifferentInProducts') }}
    </d-badge>

    <dl>
      <dt>{{ $t('order.warehouse.boxes.status.boxesCollectedBy') }}:</dt>
      <dd>
        <template v-if="boxesCollectedBy && boxesCollectedBy.length">
          {{ boxesCollectedBy.join(', ') }}
        </template>
        <template v-else>
          &mdash;
        </template>
      </dd>
      <dt>{{ $t('order.warehouse.boxes.status.boxesVerifiedBy') }}:</dt>
      <dd>
        <template v-if="boxesVerifiedBy && boxesVerifiedBy.length">
          {{ boxesVerifiedBy.join(', ') }}
        </template>
        <template v-else>
          &mdash;
        </template>
      </dd>
      <dt>{{ $t('order.warehouse.boxes.status.boxesCollected') }}:</dt>
      <dd>
        <strong v-if="boxesCollected" class="text-success">{{ $t('ui.yes') }} ({{ boxesCollectedCount }} / {{ boxesCount }})</strong>
        <strong v-else class="text-danger">{{ $t('ui.no') }} ({{ boxesCollectedCount }} / {{ boxesCount }})</strong>

        <d-badge
          v-if="boxesCollectedToday"
          theme="success"
          size="sm"
          class="ml-2">
          {{ $t('order.warehouse.boxes.status.boxesCollectedToday') }}
        </d-badge>
      </dd>
      <dt>{{ $t('order.warehouse.boxes.status.boxesVerified') }}:</dt>
      <dd>
        <strong v-if="boxesVerified" class="text-success">{{ $t('ui.yes') }} ({{ boxesVerifiedCount }} / {{ boxesCount }})</strong>
        <strong v-else class="text-danger">{{ $t('ui.no') }} ({{ boxesVerifiedCount }} / {{ boxesCount }})</strong>

        <d-badge
          v-if="boxesVerifiedToday"
          theme="success"
          size="sm"
          class="ml-2">
          {{ $t('order.warehouse.boxes.status.boxesVerifiedToday') }}
        </d-badge>
      </dd>
      <dt>{{ $t('order.warehouse.boxes.status.boxesVerificationStatus') }}:</dt>
      <dd>
        <template v-if="boxesVerificationStatus">
          <strong v-if="boxesVerificationStatus === 'FULL'" class="text-success">
            {{ $t('order.warehouse.boxes.status.full') }}
          </strong>
          <strong v-else-if="boxesVerificationStatus === 'PARTIAL'" class="text-warning">
            {{ $t('order.warehouse.boxes.status.partial') }}
          </strong>
        </template>
        <strong v-else class="text-light">
          {{ $t('ui.lack') }}
        </strong>
      </dd>
      <dt v-if="boxesReturnedBy && boxesReturnedBy.length">
        {{ $t('order.warehouse.boxes.status.boxesReturnedBy') }}:
      </dt>
      <dd v-if="boxesReturnedBy && boxesReturnedBy.length">
        {{ boxesReturnedBy.join(', ') }}
      </dd>
      <dt v-if="boxesReturnedBy && boxesReturnedBy.length">
        {{ $t('order.warehouse.boxes.status.boxesReturned') }}:
      </dt>
      <dd v-if="boxesReturnedBy && boxesReturnedBy.length">
        <strong v-if="boxesReturned" class="text-success">{{ $t('ui.yes') }} ({{ boxesReturnedCount }} / {{ boxesCount }})</strong>
        <strong v-else class="text-danger">{{ $t('ui.no') }} ({{ boxesReturnedCount }} / {{ boxesCount }})</strong>

        <d-badge
          v-if="boxesReturnedToday"
          theme="success"
          size="sm"
          class="ml-2">
          {{ $t('order.warehouse.boxes.status.boxesReturnedToday') }}
        </d-badge>
      </dd>
    </dl>
  </fieldset>
</template>

<script>
export default {
  name: 'orders-list-boxes-status',
  props: [
    'boxes',
    'boxesCount',
    'boxesCollected',
    'boxesCollectedBy',
    'boxesCollectedCount',
    'boxesCollectedToday',
    'boxesReturned',
    'boxesReturnedBy',
    'boxesReturnedCount',
    'boxesReturnedToday',
    'boxesVerificationStatus',
    'boxesVerified',
    'boxesVerifiedBy',
    'boxesVerifiedCount',
    'boxesVerifiedToday',
    'differentInProducts'
  ],
  computed: {

  }
}
</script>

<style lang="scss" scoped>
.boxes-info {
  border: 1px solid #aaa;
  border-radius: 5px;
  font-size: 11px;
  margin-top: 10px;
  padding: 0 10px;

  &.has-differents-in-products {
    border-color: #c4183c;

    legend {
      color: #c4183c;
    }

    .has-differnets-in-products-badge {
      font-size: 11px;
    }
  }

  legend {
    display: inline;
    font-size: 12px;
    font-weight: bold;
    margin: 10px 0 5px 10px;
    padding: 0 10px;
    width: auto;
  }

  dl {
    display: grid;
    grid-auto-columns: auto;
    grid-column-gap: 20px;
    grid-template-columns: 150px calc(100% - 170px);
    margin: 0 0 5px 0;

    dt {
      white-space: nowrap;
    }

    dt,
    dd {
      margin: 0;
      padding: 3px 0;
    }
  }
}
</style>
